import CurationStatusBadge from 'domains/scraper-product/atoms/curation-status-badge'
import GenderBadge from 'domains/scraper-product/atoms/gender-badge'
import ScraperProductAvailableBadge from 'domains/scraper-product/atoms/available-badge'
import { Badge, Button } from 'reactstrap'
import PropTypes from 'prop-types'
import { CURATION_STATUS } from 'domains/scraper-product/constants'
import StringUtils from 'utils/string-util'
import { ScraperProductStatusBadge } from 'domains/scraper-product/atoms/scraper-product-status-badge'
import StatusBadge from 'components/atoms/status-badge'
import ScraperProductIsInStockBadge from 'domains/scraper-product/atoms/scraper-product-is-in-stock-badge'

const propTypes = {
  scraperProduct        : PropTypes.object,
  onClickWebsite        : PropTypes.func,
  onClickCurate         : PropTypes.func,
  onCliCkRejectCuration : PropTypes.func,
  field                 : PropTypes.func,
  component             : PropTypes.func,
  onClickChangeStatus   : PropTypes.func,
  onClickUpdatePrice    : PropTypes.func
}

const defaultProps = {
  onClickWebsite        : () => { },
  onClickCurate         : () => { },
  onCliCkRejectCuration : () => { },
  onClickChangeStatus   : () => { },
  onClickUpdatePrice    : () => { }
}

const ScraperProductTableRow = ({
  scraperProduct,
  onClickWebsite,
  onClickCurate,
  onCliCkRejectCuration,
  onClickChangeStatus,
  onClickUpdatePrice
}) => {
  const {
    id,
    original_sku,
    gender,
    brand,
    brand_classifications,
    category,
    price,
    available_on_source,
    curation_status,
    website,
    product
  } = scraperProduct
  const buttonClassName = 'align-self-center my-2'

  const CellValue = ({ field, component }) => (
    field
      ? component
      : <StatusBadge color='warning' label='-' />
  )

  const showCurateRejectButton = (
    curation_status != CURATION_STATUS.CURATED_AUTOMATICALLY &&
    curation_status != CURATION_STATUS.CURATED_MANUALLY &&
    curation_status != CURATION_STATUS.REJECTED
  )

  const showUpdatePriceButton = product !== null
  const showEnableButton      = !showCurateRejectButton && product?.status === 'disabled'
  const showDisableButton     = !showCurateRejectButton && product?.status === 'enabled'

  return (
    <tr>
      { /* Scraper Product Attributes */ }
      <td><CellValue field={ id } component={ id } /></td>
      <td><CellValue field={ original_sku } component={ original_sku } /></td>
      <td>
        <CellValue
          field={ gender }
          component={ <GenderBadge gender={ gender } /> }
        />
      </td>
      <td><CellValue field={ brand } component={ brand } /></td>
      <td>
        {
          brand_classifications.length > 0
            ?  brand_classifications.map((brandClass) => (
              <div key={ `brand-class-${brandClass.name}` }>
                <Badge color='default'>
                  { brandClass.name }
                </Badge>
              </div>
            ))
            : <Badge color='warning'>{ '-' }</Badge>
        }
      </td>
      <td><CellValue field={ category } component={ category } /></td>
      <td><ScraperProductAvailableBadge available={ available_on_source } /></td>
      <td>
        <CellValue
          field={ price }
          component={ StringUtils.currencyCase(price) }
        />
      </td>
      <td>
        <CellValue
          field={ curation_status }
          component={ <CurationStatusBadge curation_status={ curation_status } /> }
        />
      </td>
      <td><CellValue field={ website?.name } component={ website?.name } /> </td>

      { /* Productable Attributes */ }
      <td><ScraperProductIsInStockBadge isInStock={ product?.is_in_stock } /></td>
      <td>
        <CellValue
          field={ product?.price }
          component={ StringUtils.currencyCase(product?.price) }
        />
      </td>
      <td><ScraperProductStatusBadge  status={ product?.status } /></td>

      { /* Action Buttons */ }
      <td className="d-flex flex-column bd-highlight mb-3">
        <Button
          size='sm'
          color='info'
          className={ buttonClassName }
          onClick={ () => onClickWebsite(website?.url) }
        >
          { 'Website' }
        </Button>

        {
          showCurateRejectButton && (
            <Button
              size='sm'
              color='primary'
              className={ buttonClassName }
              onClick={ () => onClickCurate(scraperProduct) }
            >
              { 'Curate' }
            </Button>
          )
        }

        {
          showCurateRejectButton && (
            <Button
              size='sm'
              color='danger'
              className={ buttonClassName }
              onClick={ () => onCliCkRejectCuration(id) }
            >
              { 'Reject' }
            </Button>
          )
        }

        {
          showUpdatePriceButton && (
            <Button
              size='sm'
              color='primary'
              className={ buttonClassName }
              onClick={ () => onClickUpdatePrice(scraperProduct) }
            >
              { 'Update Price' }
            </Button>
          )
        }

        {
          showEnableButton && (
            <Button
              size='sm'
              color={ 'success' }
              className={ buttonClassName }
              onClick={ () => onClickChangeStatus(id, product?.status) }
            >
              { 'Enable' }
            </Button>
          )
        }
        {
          showDisableButton && (
            <Button
              size='sm'
              color='danger'
              className={ buttonClassName }
              onClick={ () => onClickChangeStatus(id, product?.status) }
            >
              { 'Disable' }
            </Button>
          )
        }
      </td>
    </tr>
  )
}

ScraperProductTableRow.propTypes    = propTypes
ScraperProductTableRow.defaultProps = defaultProps

export default ScraperProductTableRow
